/**
 * ACT2-1108: toasts fired from the setup panel. The app's toasts sit bottom-right, which is where the panel
 * is on a wide screen, so a toast there covers the next step and "Try it". These go bottom-center, over
 * the home's empty lower half. Only the panel's own toasts move; every other toast stays where it was.
 */
import type { ExternalToast } from 'sonner';

export const SETUP_PANEL_TOAST: ExternalToast = { position: 'bottom-center' };
